export default "/profile/images/ronm-bg.png?b05029b9e5300673eabd0807011a17fb";